import React from 'react';
import { DialogActions, Button, Box, CircularProgress } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

export const STANDARD_DIALOG_FOOTER_SX = {
  backgroundColor: '#FAFAFA',
  borderTop: '1px solid #E0E0E0',
  px: 3,
  py: 2,
  gap: 2,
  justifyContent: 'space-between',
};

/**
 * Shared footer for multi-step StandardDialog wizards.
 * Left: Back (when not first step), then Cancel.
 * Right: Apply to form (optional), Save (every step), Next (hidden on last step).
 * All buttons use global-outlined-button styling.
 */
const StandardDialogWizardFooter = ({
  onCancel,
  onSave,
  onBack,
  onNext,
  activeStep = 0,
  totalSteps,
  saveLabel = 'Save',
  loading = false,
  saveDisabled = false,
  nextDisabled = false,
  onApply,
  showApply = false,
  applyCount = 0,
  applyDisabled = false,
}) => {
  const isLastStep = activeStep >= totalSteps - 1;
  const showBack = activeStep > 0;
  const showNext = !isLastStep;

  return (
    <DialogActions sx={STANDARD_DIALOG_FOOTER_SX}>
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        {showBack && (
          <Button
            onClick={onBack}
            startIcon={<ArrowBackIcon />}
            className="global-outlined-button"
          >
            Back
          </Button>
        )}
        <Button onClick={onCancel} className="global-outlined-button">
          Cancel
        </Button>
      </Box>

      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        {showApply && (
          <Button
            onClick={onApply}
            startIcon={<AutoAwesomeIcon />}
            className="global-primary-button"
            disabled={applyDisabled}
            sx={{ whiteSpace: 'nowrap' }}
          >
            Apply{applyCount > 0 ? ` ${applyCount}` : ''} to form
          </Button>
        )}
        <Button
          onClick={onSave}
          className="global-outlined-button"
          disabled={loading || saveDisabled}
        >
          {loading ? (
            <CircularProgress size={20} sx={{ color: '#1D3DFC' }} />
          ) : (
            saveLabel
          )}
        </Button>
        {showNext && (
          <Button
            onClick={onNext}
            endIcon={<ArrowForwardIcon />}
            className="global-outlined-button"
            disabled={nextDisabled}
          >
            Next
          </Button>
        )}
      </Box>
    </DialogActions>
  );
};

export default StandardDialogWizardFooter;
